/* eslint-disable import/prefer-default-export */
import { Map } from 'immutable'
import { useSelector } from 'react-redux'
import { useFeatureFlagVariantKey } from '@posthog/react'
import { useTranslation } from '../../services/static-text/hooks'
import { POSTHOG_FEATURE_FLAGS } from '../PostHog/flags'
import { NAVIGATION_PRIMARY_V2_STATIC_KEY } from './navigation-primary-v2-static-key'

/**
 * The localized AI-search placeholder for the primary nav search input.
 * Returns the copy only on the 'test' arm of the `ai-search-web` experiment;
 * every other variant (including 'control' and undecided flags) gets undefined
 * so the search input keeps its default placeholder.
 *
 * Hydration-safe: ignore PostHog until bootstrapComplete so SSR and first
 * client paint share the default placeholder (intentional flicker after).
 */
export function useAiSearchPlaceholder (): string | undefined {
  const bootstrapComplete = useSelector((state: { app?: Map<string, unknown> }) => {
    const { app } = state
    if (app == null || !Map.isMap(app)) {
      return false
    }
    return !!app.get('bootstrapComplete')
  })
  const variant = useFeatureFlagVariantKey(POSTHOG_FEATURE_FLAGS.AI_SEARCH_WEB)
  // `useTranslation` lives in untyped JS whose JSDoc names a typedef that does
  // not exist, so TS infers its return as `typeof useTranslation`. Cast at the
  // call site (as OracleCopyButton does) until hooks.js is properly typed.
  const translate = useTranslation(
    NAVIGATION_PRIMARY_V2_STATIC_KEY,
  ) as unknown as (literal: string) => string
  if (!bootstrapComplete || variant !== 'test') return undefined
  return translate('searchPlaceholder')
}
